exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ::ng-deep #gist-app{\n  display: none !important;\n} */\n\n/* ::ng-deep .navbar-default{\n  display: none;\n} */\n\n.loaders {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  display: block;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background: #fff;\n  opacity: .9;\n  display: flex;\n  z-index: 99999;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main